/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'WorkRecord',dictionary:{"de":{"references":{"project":"Projekt","projectTimeReport":"Baustellenbericht","worker":"Mitarbeiter","activity":"Tätigkeit"},"remark":"Anmerkung","times":{"start":"Start","end":"Ende"}}}})
import { Login } from './Login';
import { Worker } from './Worker';
import { ProjectTimeReport } from './ProjectTimeReport';
import { WorkerTimeReport } from './WorkerTimeReport';
import { Project } from './Project';
import { Activity } from './Activity';

export class WorkRecord extends _BaseModel {
	
	static toString() {
		return 'WorkRecord'
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.WorkRecord.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'WorkRecord', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkRecord.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkRecord', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkRecord.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkRecord', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'WorkRecord', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'WorkRecord', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.WorkRecord.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'WorkRecord', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkRecord'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkRecord) || _BaseModel.t('rules.reference', {modelName:'WorkRecord', path:'meta.currentDocument'}) ],
				model: WorkRecord,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'WorkRecord', path:'meta.revisions'}) ],
				model: WorkRecord,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	worker:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				itemText: "references.person.__getters.lastFirstName",
				optionName: "person",
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Worker) || _BaseModel.t('rules.reference', {modelName:'WorkRecord', path:'references.worker'}) ],
				model: Worker,
				returnObject: true,
},
    
	},
	
					
	projectTimeReport:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.ProjectTimeReport'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof ProjectTimeReport) || _BaseModel.t('rules.reference', {modelName:'WorkRecord', path:'references.projectTimeReport'}) ],
				model: ProjectTimeReport,
				returnObject: true,
},
    
	},
	
					
	workerTimeReport:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkerTimeReport'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkerTimeReport) || _BaseModel.t('rules.reference', {modelName:'WorkRecord', path:'references.workerTimeReport'}) ],
				model: WorkerTimeReport,
				returnObject: true,
},
    
	},
	
					
	project:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Project'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WorkRecord', path:'references.project'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Project) || _BaseModel.t('rules.reference', {modelName:'WorkRecord', path:'references.project'}) ],
				model: Project,
				returnObject: true,
},
    
	},
	
					
	activity:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Activity'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WorkRecord', path:'references.activity'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Activity) || _BaseModel.t('rules.reference', {modelName:'WorkRecord', path:'references.activity'}) ],
				model: Activity,
				returnObject: true,
},
    
	},
	
},
				
	remark:{
		type: 'string',
		__component: 'v-textarea',
    
		__bind: {				label: _BaseModel.t('models.WorkRecord.remark'),
				rows: 1,
				autoGrow: true,
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'WorkRecord', path:'remark'}) ],
},
    
	},
	
			times: 				{
					
	start:{
		type: 'date',
		__component: 'date-time-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkRecord.times.start'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WorkRecord', path:'times.start'}),(value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkRecord', path:'times.start'}) ],
},
    __isDateTime: true,
	},
	
					
	end:{
		type: 'date',
		__component: 'date-time-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkRecord.times.end'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WorkRecord', path:'times.end'}),(value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkRecord', path:'times.end'}) ],
},
    __isDateTime: true,
	},
	
},
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.WorkRecord._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, remark='', times={}, _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.remark=remark;
		this.times=TimesClass.create(times);
		this._id=_id;
	}

	static create(data) {
		return new WorkRecord(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof WorkRecord || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : WorkRecord.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof WorkRecord ? item : WorkRecord.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({worker=undefined, projectTimeReport=undefined, workerTimeReport=undefined, project=undefined, activity=undefined, }={}){
		this.worker= (worker instanceof Worker || typeof worker === 'string' || !worker) ? worker : Worker.create(worker);
		this.projectTimeReport= (projectTimeReport instanceof ProjectTimeReport || typeof projectTimeReport === 'string' || !projectTimeReport) ? projectTimeReport : ProjectTimeReport.create(projectTimeReport);
		this.workerTimeReport= (workerTimeReport instanceof WorkerTimeReport || typeof workerTimeReport === 'string' || !workerTimeReport) ? workerTimeReport : WorkerTimeReport.create(workerTimeReport);
		this.project= (project instanceof Project || typeof project === 'string' || !project) ? project : Project.create(project);
		this.activity= (activity instanceof Activity || typeof activity === 'string' || !activity) ? activity : Activity.create(activity);
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}

class TimesClass {
	constructor({start=undefined, end=undefined, }={}){
		this.start=start;
		this.end=end;
	}

	static create(data) {
		return new TimesClass(data);
	}
}
